import React from 'react';
import { 
  Alert, 
  AlertTitle, 
  Button, 
  Box, 
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import { 
  ExitToApp as ExitIcon,
  Person as PersonIcon,
  AdminPanelSettings as AdminIcon
} from '@mui/icons-material';
import { useProxySession } from '../contextProviders/ProxySessionProvider';
import { useAuthApi } from '../hooks/useAuthApi';

const ProxyModeBanner = () => {
  const { isProxyMode, proxySession, getAdminUser, getCurrentUser } = useProxySession();
  const { exitProxy, loading } = useAuthApi();

  if (!isProxyMode || !proxySession) {
    return null;
  }

  const adminUser = getAdminUser();
  const currentUser = getCurrentUser();

  const handleExitProxy = async () => {
    const result = await exitProxy();
    if (result && result.success) {
      // Navigation is handled by exitProxy function
      console.log('Successfully exited proxy mode');
    }
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <Alert
      severity="warning"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 0
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, py: 1.5, pl: 2 }}>
        <AlertTitle sx={{ mb: 0, fontWeight: 600, color: '#b26a00' }}>
          🔄 Proxy Mode Active
        </AlertTitle>
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
          <AdminIcon fontSize="small" />
          <strong>{adminUser?.name}</strong>
          <span>viewing as</span>
          <PersonIcon fontSize="small" />
          <strong>{currentUser?.name}</strong>
          <span>({currentUser?.email})</span>
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
          Session started: {formatDateTime(proxySession.startedAt)}
        </Typography>
      </Box>
      {/*
        To unhide the Exit User button, simply uncomment the Button block below.
      
      */}
    </Alert>
  );
};

export default ProxyModeBanner;